import React from "react";
import styled from "styled-components";
import { FiPlus } from "react-icons/fi";

export const Title = styled.h3`
  text-align: center;
  margin-bottom: 1rem;
`;
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 2rem;
`;

export const ButtonCreateAdmin = styled.input.attrs({
  type: "submit",
})`
  border: none;
  cursor: pointer;
  padding: 0.5rem 2rem;
  border-radius: 999rem;
  background-color: #4779f4;
  color: #fff;
`;

export const ImageSelected = styled.img`
  width: 8rem;
  height: 8rem;
  border-radius: 9999px;
  align-self: center;
  object-fit: cover;
`;
export const InputLabel = styled.label`
  margin: 0.5rem;
`;
export const InputAdmin = styled.input`
  border: none;
  outline: none;
  border-radius: 999px;
  background-color: #f0f0f0;
  padding: 0.3rem 1rem;
  margin-bottom: 0.5rem;
`;
export const InputTextArea = styled.textarea`
  border: none;
  outline: none;
  border-radius: 1rem;
  background-color: #f0f0f0;
  padding: 0.5rem 1rem;
  margin-bottom: 0.5rem;
`;

export const SelectRoles = styled.select`
  border: none;
  outline: none;
  background-color: #f0f0f0;
  border-radius: 999px;
  padding: 0.3rem 1rem;

  width: 48%;
  margin-bottom: 0.5rem;
  text-align: center;
`;

export const IconPlus = () => (
  <div
    style={{
      width: "8rem",
      height: "8rem",
      borderRadius: "9999px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#F0F0F0",
      alignSelf: "center",
    }}
  >
    <FiPlus color="#fff" size={100} />
  </div>
);
